import { Outlet } from '@tanstack/react-router';
import { AnimatePresence } from 'motion/react';

import { SettingSidebar } from './setting.sidebar';

import { Separator } from '@/shared/components/shadcn/separator';

export function SettingLayout() {
  return (
    <div className="flex flex-col p-10">
      <h3 className="text-2xl font-bold">Settings</h3>
      <Separator className="my-6" />
      <div className="flex gap-12">
        <SettingSidebar />
        <div className="flex-1">
          <AnimatePresence mode="wait">
            <Outlet />
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}
